import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import React from 'react';

import { DetailsValue } from '@/components/molecules/DetailsValue';
import { useTransactionDetailsFields } from '@/hooks/useTransactionDetailsFields';
import { BitsoBank } from '@/types/bitsoBank';
import { DetailsField } from '@/types/detailsField';
import { Transaction } from '@/types/transaction';

interface Props {
  readonly transaction: Transaction;
  readonly fromBanks: readonly BitsoBank[];
  readonly toBanks: readonly BitsoBank[];
}

export const TransactionDetailsDrawerContent: React.FC<Props> = (
  props: Props,
): React.ReactElement => {
  const { transaction, fromBanks, toBanks } = props;

  const fields = useTransactionDetailsFields(transaction, fromBanks, toBanks);

  return (
    <Box my={4}>
      <Box my={2}>
        <Grid container={true} spacing={4}>
          {fields
            .filter((item: DetailsField | null): item is DetailsField => item !== null)
            .map((item: DetailsField): React.ReactElement => {
              const columnSpan = Math.max(item.columnSpan ?? 1, 1);

              return (
                <React.Fragment key={item.label}>
                  <Grid component={Box} size={columnSpan * 6}>
                    <Typography variant="body1" color="custom.LightGray">
                      {item.label}
                    </Typography>
                    <DetailsValue title={item.title}>{item.value}</DetailsValue>
                  </Grid>
                </React.Fragment>
              );
            })}
        </Grid>
      </Box>
    </Box>
  );
};
